import {ApiRequestor} from "@/classes/requestors/api.requestor";

export class DtoApiUpdateSponsorActivation extends ApiRequestor {
  async $update(bookingId, payload) {
    return this.$http('POST', `bookedActivity/${bookingId}`, {payload});
  }
}
